import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { routes } from "./routes/index";
import RouteItem from "./routes/index";
import Layout from "./layouts/Layout";

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          {routes.map((route: RouteItem) =>
            route.subRoutes ? (
              route.subRoutes.map((item: RouteItem) => (
                <Route key={`${route.key}`} path={`${route.path}`}>
                  <Route
                    id={`${route.title}`}
                    key={`${route.description}`}
                    path={`${item.path}`}
                    element={item.component}
                  />
                </Route>
              ))
            ) : (
              <Route
                id={`${route.title}`}
                key={`${route.description}`}
                path={`${route.path}`}
                element={route.component}
              />
            )
          )}
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
